import { MethodType } from "@/models/http/MethodType";
import { NominatimReverseResponse } from "@/models/nominatim/reverse/nominatimReverseResponse";
import HttpService from "../HttpService";
import { UrlBuilder } from "@/builders/UrlBuilder";
import ApiURLs from "@/ApiURLs";

export class NominatimHttpService {
    public static async getLocationDetails(latitude: number, longitude: number): Promise<NominatimReverseResponse> {

          const paramsObj = {
               format: `jsonv2`,
               lat: latitude.toString(),
               lon: longitude.toString(),
          };

          const url = UrlBuilder.addQueryParams(ApiURLs.getLocationDetailsByCoordinates, paramsObj);
          const response = await HttpService.send<NominatimReverseResponse>(url, MethodType.GET);

          return response.data;
    }
}